<template>
  <div class="home-container">
    <el-container class="page-container">
      <el-header>
        <div class="nav-bar">
          <div class="nav-logo fl">
            <!--<img src="../../assets/images/logo.png" class="fl">-->
            <div class="fl">{{slogon}}</div>
            <div class="fl" @click="onSwitch" style="marginLeft:20px;cursor:pointer;">
              <i v-if="!isCollapse" class="el-icon-s-fold" style="fontSize:22px;"></i>
              <i v-else class="el-icon-s-unfold" style="fontSize:22px;"></i>
            </div>
          </div>
          <div class="nav-setting fr" style="display:flex;">
            <!--
            <div style="display:flex;align-items:center;margin-right:8px;">
              <el-dropdown @command="languageOnChange">
                <span class="el-dropdown-link">
                  {{language}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="language in languageOptions"
                        :key="language.value"
                        :label="language.text"
                        :command="language.text">
                    {{language.text}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            -->
            <div class="nav-user fl" style="display:flex;">
              <img src="../../assets/images/home-user-icon.png">
              <div style="display:flex;flex-direction:column;justify-content:center;width:10rem;overflow:hidden;"><p>{{userNameLanguageAdapted || 'admin'}}</p></div>
            </div>
            <!--
            <div class="settings fl" @click="settingsOnClick">
              <img src="../../assets/images/settings-icon.png">
            </div>
            -->
            <div class="logout fr" @click="logout">
              <img src="../../assets/images/logout-icon.png">
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside :width="isCollapse ? '64px' : '200px'">
          <el-menu
            :default-active="$route.path"
            background-color="#002033"
            text-color="#fff"
            active-text-color="#ffd04b"
            :collapse="isCollapse"
            :collapse-transition="false"
            router
            unique-opened
            :defaultOpeneds="openedMenu"
            class="menu">
            <el-menu-item index="/">
              <i class="el-icon-house"></i>
              <span slot="title">首页</span>
            </el-menu-item>

            <!-- 晚疫病预测 -->
            <el-submenu index="100" v-if='userRole == "pm" || userRole == "expert" || userRole == "chengdeqixiang"'>
              <template slot="title">
                <i class="el-icon-first-aid-kit"></i>
                <span slot="title">晚疫病</span>
              </template>
              <el-menu-item index="/warning-forecast" v-if='userRole == "pm" || userRole == "expert"'>中心病株预测</el-menu-item>
              <el-menu-item index="/late-blight">河北晚疫病预测</el-menu-item>
            </el-submenu>

            <!-- 账号角色管理 -->
            <el-submenu index="400" v-if='userRole == "pm" || userRole == "expert"'>
              <template slot="title">
                <i class="el-icon-s-check"></i>
                <span slot="title">账号角色管理</span>
              </template>

              <el-menu-item index="/account">账号管理</el-menu-item>

              <el-menu-item index="/staff-role-list" v-if='userRole == "pm"'>授权管理</el-menu-item>
              <el-menu-item index="/role-permission-management" v-if='userRole == "pm"'>角色权限配置</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>

        <el-main>
          <keep-alive :exclude="['growth-rating-details', 'knowledge-base-details', 'compound-fertilizer', 'compound-fertilizer-record', 'growth-nutrient-analysis-details']">
            <router-view/>
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { SESSION_KEY_USER, LOCAL_KEY_CURRENT_LANGUAGE } from '../../constants/StorageKeys'
import { LanguageEnum } from 'utils/LanguageEnum'
import pinyin from 'js-pinyin'
import locale from 'element-ui/lib/locale'
import langEn from 'element-ui/lib/locale/lang/en'
import langZH from 'element-ui/lib/locale/lang/zh-CN'

export default {
  name: 'home',
  data () {
    return {
      userName: '',
      userNameLanguageAdapted: '',
      userRole: '',
      userCompanyID: '',
      isCollapse: false,
      slogon: '',
      openedMenu: [], // ['350'], // 当前展开的菜单

      // 多语言支持
      language: '',
      languageOptions: [],
      languageAdaption: {
        menuGroupFieldInsight: {
          menuLableGroup: '',
          menuLabelFieldOverview: '',
          menuLabelFieldDetail: '',
          menuLabelFieldComparision: '',
          menuLabelSeasonalNutrientAnalysis: '',
          menuLabelFieldDashborad: ''
        },
        menuGroupFarmCockpit: {
          menuLableGroup: '',
          menuLabelCompanyStatistic: '',
          menuLabelFarmStatistic: '',
          menuLabelCompanyNutrientDeficiencyStatistic: '',
          menuLabelFarmBasicInfo: '',
          menuLabelFieldDashborad: ''
        },
        menuGroupIrrigationManagement: {
          menuLableGroup: '',
          menuLabelSoilMoisture: '',
          menuLabelPrecipitation: ''
        },
        menuGroupMeteorological: {
          menuLableGroup: '',
          menuLabelTemperature: '',
          menuLabelGDD: '',
          menuLabelSolarRadiation: '',
          menuLabelSunlightHours: ''
        },
        menuGroupNutritionManagement: {
          menuLableGroup: '',
          menuLabelSoilAnalysis: '',
          menuLabelPetioleAnalysis: '',
          menuLabelWaterAnalysis: '',
          menuLabelFertilizerRecommendation: ''
        },
        menuGroupPlantingManagement: {
          menuLableGroup: '',
          menuLabelPlantingTimeSuggestion: ''
        },
        menuGroupCropProtectionManagement: {
          menuLableGroup: ''
        },
        menuGroupCropGrowthStatusManagement: {
          menuLableGroup: '',
          menuLabelGrowthStagePrediction: '',
          menuLabelGrowthInformation: '',
          menuLabelGrowthBySatellite: ''
        },
        menuGroupBusinessManagement: {
          menuLableGroup: ''
        },
        menuGroupTestReport4Lambweston: {
          menuLableGroup: '',
          menuLabelDownloadTestReport: ''
        }
      }
    }
  },
  created () {
    let userInfo = JSON.parse(window.sessionStorage.getItem(SESSION_KEY_USER)) || {}
    this.userName = userInfo.userName || ''
    this.userRole = userInfo.role || ''
    this.userID = userInfo.id || ''
    this.userCompanyID = userInfo.userCompanyID || ''

    // 准备系统语言
    this.language = null
    this.languageOptions = []
    let currLanguageText = window.sessionStorage.getItem(LOCAL_KEY_CURRENT_LANGUAGE)
    LanguageEnum.symbols().forEach(language => {
      this.languageOptions.push({ text: language.text, value: language.value })
      if (currLanguageText && language.text === currLanguageText) {
        this.language = currLanguageText
        window[LOCAL_KEY_CURRENT_LANGUAGE] = language // 枚举挂载在window上，方便其他页面使用
      }
    })

    if (window[LOCAL_KEY_CURRENT_LANGUAGE] === LanguageEnum.CHINESE) {
      locale.use(langZH)
      this.userNameLanguageAdapted = this.userName
      this.slogon = '保卫土豆'
    } else {
      locale.use(langEn)
      this.userNameLanguageAdapted = (pinyin.getFullChars(this.userName) === this.userName)
        ? this.userName : pinyin.getFullChars(this.userName.substring(1)) + '.' + pinyin.getFullChars(this.userName.substring(0, 1))
      this.slogon = 'Better planting, Better life'
    }
  },

  mounted () {
    let that = this

    // that.openedMenu = that.userCompanyID === '11950' ? [] : ['350'] // 对非植塔的用户，默认展开field insight

    // 准备语言版本
    if (window[LOCAL_KEY_CURRENT_LANGUAGE] === LanguageEnum.CHINESE) {
      that.languageAdaption.menuGroupFieldInsight.menuLableGroup = '数字洞察'
      that.languageAdaption.menuGroupFieldInsight.menuLabelFieldOverview = '地块总览'
      that.languageAdaption.menuGroupFieldInsight.menuLabelFieldDetail = '地块详情'
      that.languageAdaption.menuGroupFieldInsight.menuLabelFieldComparision = '地块比较'
      that.languageAdaption.menuGroupFieldInsight.menuLabelSeasonalNutrientAnalysis = '营养方案分析'

      that.languageAdaption.menuGroupFarmCockpit.menuLableGroup = '农场驾驶舱'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelCompanyStatistic = '指标统计' // 公司统计
      that.languageAdaption.menuGroupFarmCockpit.menuLabelFarmStatistic = '基地统计'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelCompanyNutrientDeficiencyStatistic = '缺素警报'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelFarmBasicInfo = '基础信息'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelFieldDashborad = '地块看板'

      that.languageAdaption.menuGroupPlantingManagement.menuLableGroup = '农事管理'
      that.languageAdaption.menuGroupPlantingManagement.menuLabelPlantingTimeSuggestion = '播种时间建议'

      that.languageAdaption.menuGroupIrrigationManagement.menuLableGroup = '灌溉管理'
      that.languageAdaption.menuGroupIrrigationManagement.menuLabelSoilMoisture = '土壤湿度'
      that.languageAdaption.menuGroupIrrigationManagement.menuLabelPrecipitation = '降雨'

      that.languageAdaption.menuGroupNutritionManagement.menuLableGroup = '营养管理'
      that.languageAdaption.menuGroupNutritionManagement.menuLabelSoilAnalysis = '土壤检测分析'
      that.languageAdaption.menuGroupNutritionManagement.menuLabelPetioleAnalysis = '叶柄检测分析'
      that.languageAdaption.menuGroupNutritionManagement.menuLabelWaterAnalysis = '灌溉水检测分析'
      that.languageAdaption.menuGroupNutritionManagement.menuLabelFertilizerRecommendation = '施肥建议'

      that.languageAdaption.menuGroupCropProtectionManagement.menuLableGroup = '植保管理(暂无)'

      that.languageAdaption.menuGroupCropGrowthStatusManagement.menuLableGroup = '作物长势'
      that.languageAdaption.menuGroupCropGrowthStatusManagement.menuLabelGrowthStagePrediction = '生育期预测'
      that.languageAdaption.menuGroupCropGrowthStatusManagement.menuLabelGrowthInformation = '长势数据'
      that.languageAdaption.menuGroupCropGrowthStatusManagement.menuLabelGrowthBySatellite = '卫星遥感'

      that.languageAdaption.menuGroupMeteorological.menuLableGroup = '环境信息'
      that.languageAdaption.menuGroupMeteorological.menuLabelTemperature = '气温'
      that.languageAdaption.menuGroupMeteorological.menuLabelGDD = '积温'
      that.languageAdaption.menuGroupMeteorological.menuLabelSolarRadiation = '日照'

      that.languageAdaption.menuGroupBusinessManagement.menuLableGroup = '经营管理(暂无)'

      that.languageAdaption.menuGroupTestReport4Lambweston.menuLableGroup = '检测报告'
      that.languageAdaption.menuGroupTestReport4Lambweston.menuLabelDownloadTestReport = '下载检测报告'
    } else {
      that.languageAdaption.menuGroupFieldInsight.menuLableGroup = 'Field insight'
      that.languageAdaption.menuGroupFieldInsight.menuLabelFieldOverview = 'Field overview'
      that.languageAdaption.menuGroupFieldInsight.menuLabelFieldDetail = 'Field detail'
      that.languageAdaption.menuGroupFieldInsight.menuLabelFieldComparision = 'Field comparision'
      that.languageAdaption.menuGroupFieldInsight.menuLabelSeasonalNutrientAnalysis = 'Nutrient analysis'

      that.languageAdaption.menuGroupFarmCockpit.menuLableGroup = 'Farm cockpit'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelCompanyStatistic = 'Indicator statistics' // 'Company status'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelFarmStatistic = 'Farm status'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelCompanyNutrientDeficiencyStatistic = 'Nutrient deficiency'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelFarmBasicInfo = 'Basic information'
      that.languageAdaption.menuGroupFarmCockpit.menuLabelFieldDashborad = 'Field dashboard'

      that.languageAdaption.menuGroupPlantingManagement.menuLableGroup = 'Planting management'
      that.languageAdaption.menuGroupPlantingManagement.menuLabelPlantingTimeSuggestion = 'Planting time suggestion'

      that.languageAdaption.menuGroupIrrigationManagement.menuLableGroup = 'Irrigation management'
      that.languageAdaption.menuGroupIrrigationManagement.menuLabelSoilMoisture = 'Soil moisture'
      that.languageAdaption.menuGroupIrrigationManagement.menuLabelPrecipitation = 'Precipitation'

      that.languageAdaption.menuGroupNutritionManagement.menuLableGroup = 'Nutrition management'
      that.languageAdaption.menuGroupNutritionManagement.menuLabelSoilAnalysis = 'Soil analysis'
      that.languageAdaption.menuGroupNutritionManagement.menuLabelPetioleAnalysis = 'Petiole analysis'
      that.languageAdaption.menuGroupNutritionManagement.menuLabelWaterAnalysis = 'Irrigation water analysis'
      that.languageAdaption.menuGroupNutritionManagement.menuLabelFertilizerRecommendation = 'Fert recommendation'

      that.languageAdaption.menuGroupCropProtectionManagement.menuLableGroup = 'Crop protection management'

      that.languageAdaption.menuGroupCropGrowthStatusManagement.menuLableGroup = 'Crop growth status'
      that.languageAdaption.menuGroupCropGrowthStatusManagement.menuLabelGrowthStagePrediction = 'Growth stage prediction'
      that.languageAdaption.menuGroupCropGrowthStatusManagement.menuLabelGrowthInformation = 'Growth data'
      that.languageAdaption.menuGroupCropGrowthStatusManagement.menuLabelGrowthBySatellite = 'Satellite images'

      that.languageAdaption.menuGroupMeteorological.menuLableGroup = 'Environment info'
      that.languageAdaption.menuGroupMeteorological.menuLabelTemperature = 'Air temperature'
      that.languageAdaption.menuGroupMeteorological.menuLabelGDD = 'Growth day degree'
      that.languageAdaption.menuGroupMeteorological.menuLabelSolarRadiation = 'Solar radiation'

      that.languageAdaption.menuGroupBusinessManagement.menuLableGroup = 'Business management'

      that.languageAdaption.menuGroupTestReport4Lambweston.menuLableGroup = 'Test report'
      that.languageAdaption.menuGroupTestReport4Lambweston.menuLabelDownloadTestReport = 'Download test report'
    }
  },

  activated () {
    let that = this
    console.log(that.$route.name + ' activated() route params', that.$route.params)
    if (that.$route.params.reload) {
      window.location.reload()
    }
  },

  methods: {
    languageOnChange (languageText) {
      let that = this
      console.log(that.$route.name + ' languageOnChange() selected languageText=', languageText)
      if (languageText === that.language) {
        return
      }
      that.language = languageText
      window.sessionStorage.setItem(LOCAL_KEY_CURRENT_LANGUAGE, languageText)
      window.location.reload()
    },

    logout () {
      window.sessionStorage.removeItem(SESSION_KEY_USER)
      this.$router.push('/login')
    },

    onSwitch () {
      this.isCollapse = !this.isCollapse
      window.dispatchEvent(new Event('resize'))
    },

    settingsOnClick () {
      console.log(this.$route.name + ' settingsOnClick()')
      this.$router.push('/settings/password')
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  .page-container{
    height: 100%;
    .el-container {
      height: 100%;
      min-height: 0;
    }
    .el-header {
      padding: 0;
      .nav-bar {
        box-sizing: border-box;
        padding: 5px 30px 0 15px;
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-bottom: 2px solid #666;
        .nav-logo > img.fl {
          display: block;
          width: 118px;
          height: 50px;
          padding-right: 45px;
        }
        .nav-logo > div {
          margin-top: 16px;
          font-size: 16px;
        }
        .nav-setting > .nav-user {
          width: 170px;
          img {
            vertical-align: middle;
            padding-right: 15px;
          }
        }
        .logout {
          margin-top: 7px;
          cursor: pointer;
        }
        .settings {
          margin-top: 7px;
          margin-right: 8px;
          cursor: pointer;
        }
      }
    }
    .el-aside {
      .menu {
        height: 100%;
        z-index: 1200
      }
    }
    .el-main {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue